export const stats = [
  { value: '+500', label: "Unità e Schede Operative Pronte all'Uso" },
  { value: '+1.200', label: 'Docenti Soddisfatti' },
  { value: '4.500+', label: 'Ore di Preparazione Risparmiate' },
  { value: '98%', label: 'Lo Raccomandano' },
]

export const differenceStats = [
  { value: '+500', label: 'Unità e Attività (1° al 5° anno Superiori)' },
  { value: '5', label: 'Volumi Digitali Completi (PDF)' },
  { value: '100%', label: 'Download Immediato' },
]

export const beforeItems = [
  'Ore passate a creare bilanci ed esercizi che "quadrano" su Excel ogni maledetta domenica',
  "Lezioni confuse perché mancano supporti visivi per spiegare concetti astratti come l'ammortamento o il patrimonio",
  'Nessuna connessione reale tra la teoria del libro e la pratica della fatturazione elettronica o dei nuovi principi contabili',
  'Difficoltà nel creare verifiche inclusive (BES/DSA) senza lavorare di notte',
  'Studenti demotivati che pensano che "l\u2019aziendale sia solo una lista di numeri noiosi"',
]

export const afterItems = [
  '5 minuti di revisione e sei pronto per entrare in classe con la sicurezza di un professionista',
  'Schemi visuali e moderni che rendono la partita doppia chiara al primo sguardo',
  'Casi aziendali reali integrati in ogni singola unità',
  "Quiz, verifiche, soluzioni e rubriche già pronti al 100%: niente più calcoli errati all'ultimo minuto",
  "Studenti che capiscono il valore dell'economia, sanno leggere un bilancio e si sentono pronti per il mondo del lavoro",
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: 'Ansia da partita doppia: arrivare in classe temendo che un esercizio complesso non quadri davanti agli studenti',
  },
  {
    emoji: '⏱️',
    text: "Domeniche in ufficio: passare l'intera domenica a creare mastrini e registrazioni contabili invece di stare con la tua famiglia",
  },
  {
    emoji: '🤷',
    text: 'Caos operativo: faticare a trovare esempi di fatture o bilanci civilistici che siano aggiornati e visuali',
  },
  {
    emoji: '📋',
    text: 'Valutazione infinita: nessuna griglia di valutazione chiara o test allineato con i programmi ministeriali',
  },
  {
    emoji: '😴',
    text: 'Studenti persi: alunni che mollano perché la contabilità sembra un linguaggio incomprensibile (specialmente BES/DSA)',
  },
]

export const packItems = [
  {
    emoji: '📚',
    title: '5 Volumi PDF basati sull\u2019Anno Scolastico (1° – 5° Superiore)',
    text: 'Un curriculum completo: dal calcolo commerciale del primo anno alla Maturità del quinto',
  },
  {
    emoji: '🧾',
    title: 'Kit Documenti e Registrazioni Visive',
    text: 'Modelli di fatture, DDT, cambiali e schemi di Libro Giornale pronti da proiettare o stampare',
  },
  {
    emoji: '✏️',
    title: 'Script delle Lezioni «Pronti al Volo»',
    text: 'Suggerimenti didattici che ti dicono esattamente come introdurre concetti difficili come il bilancio civilistico',
  },
  {
    emoji: '📐',
    title: 'Aziendale Visuale: Mappe e Schemi',
    text: 'Infografiche moderne per spiegare i flussi gestionali, il reddito e il patrimonio senza stancare gli occhi',
  },
  {
    emoji: '📊',
    title: 'Verifiche, Soluzioni e BES/DSA',
    text: 'Strumenti di valutazione completi e versioni facilitate per una didattica davvero inclusiva',
  },
  {
    emoji: '🔑',
    title: 'Answer Keys (Soluzioni Complete)',
    text: 'Ogni esercizio è accompagnato dalla sua soluzione dettagliata: correzioni istantanee e zero stress',
  },
]

export const pageSamples = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/uL94dBBChcesgiR425Ffo8/Captura-de-pantalla-2026-09-07-a-las-11.19.24_p._m._(1).webp',
    level: '1° Anno · I Documenti',
    title: 'Esercizi Modulo 5: Fattura, DDT e Nota di Credito',
    caption:
      'Quattro attività a difficoltà crescente: ordina i documenti del ciclo di vendita, abbina ogni documento alla sua descrizione, completa un preventivo e crea la nota di credito per il reso.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2UwtcdKS49xo3sNpqoiR8h/Captura-de-pantalla-2026-09-07-a-las-11.22.08_p._m..webp',
    level: '2° Anno · Natura dei Conti',
    title: 'Attività 2 — Natura del Conto e Effetto del Dare',
    caption:
      'Tabella da completare con otto conti reali (Cassa, Debiti Banca, Vendite, Fondo Ammortamento…): natura del conto e se il DARE aumenta o diminuisce il saldo.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/941k2tp7WPqc3DQcvtGkkX/Captura-de-pantalla-2026-09-07-a-las-11.21.16_p._m..webp',
    level: '3° Anno · Partita Doppia',
    title: 'Operazioni in Mastrini: Acquisto e Vendita di Merce',
    caption:
      'Ogni operazione registrata nei mastrini a T con frecce di aumento e diminuzione, più il box «Interpretazione» che spiega l’effetto su patrimonio e reddito.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/k9Qw16khm9NYRTvMh1vYax/Captura-de-pantalla-2026-09-07-a-las-11.24.43_p._m..webp',
    level: '4° Anno · Il Bilancio',
    title: 'La Struttura del Bilancio Civilistico',
    caption:
      'Scheda visuale sul documento depositato al Registro delle Imprese e su chi lo consulta: banche, investitori e fisco, con schema illustrato pronto da proiettare.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2qyV7UVG76JyRKiteyFFDt/Captura-de-pantalla-2026-09-07-a-las-11.25.40_p._m..webp',
    level: '5° Anno · La Maturità',
    title: 'La Struttura del Budget di Cassa Mensile',
    caption:
      'Prospetto semestrale con entrate, uscite, net cash flow e saldo cumulato, evidenziando il mese critico e le azioni preventive da adottare.',
  },
]

export const bonuses = [
  {
    title: 'Il Piano Docente 10 Minuti',
    was: '€17',
    text: 'Pianifica una lezione completa in 10 minuti: obiettivi, attività e verifica già impostati',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/1056e702-6b91-4d61-a188-61e237e33daa.jpg',
  },
  {
    title: 'Diagnosi Classe Zero™',
    was: '€17',
    text: "Il test d'ingresso rapido per capire subito il livello reale della tua classe",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/f2b904de-670c-4a4e-bdee-3aca7403d04d.jpg',
  },
  {
    title: 'Kit Semplifica DSA/BES™',
    was: '€17',
    text: "L'inclusione intelligente: adatta l'Economia Aziendale senza raddoppiare il lavoro",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/ba021daf-62c3-4f07-a924-f316313e06f6.jpg',
  },
  {
    title: 'Correzione Lampo™',
    was: '€17',
    text: 'Griglie e codici pronti per dimezzare i tempi di correzione senza perdere qualità',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/d7e9d8ed-5d53-4ab1-a72e-f25d7593387b.jpg',
  },
  {
    title: 'Pronto Soccorso Concetti Difficili™',
    was: '€17',
    text: 'Spiegazioni a prova di bomba, metafore potenti e mini-script per non perdere nessuno',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/fdf242a6-ca63-4a37-9d51-dedb80e083b8.jpg',
  },
]

export const offerRows = [
  { label: 'AZIENDALE PRONTA™ (5 Volumi Digitali PDF)', value: '€77' },
  { label: '5 Bonus Strategici Esclusivi', value: '€85' },
]

export const testimonials = [
  {
    quote:
      'Finalmente i miei studenti hanno capito la partita doppia grazie agli schemi visuali. Ho recuperato i miei weekend!',
    name: 'Chiara M.',
    location: 'Milano 🇮🇹',
  },
  {
    quote:
      'Le schede per i ragazzi DSA sono eccezionali. Non devo più riscrivere tutto da capo la sera.',
    name: 'Luca B.',
    location: 'Roma 🇮🇹',
  },
  {
    quote:
      'Il kit Excel è stato la svolta per le mie ore in laboratorio. Tutto pronto e testato.',
    name: 'Elena V.',
    location: 'Torino 🇮🇹',
  },
]

export const faqs = [
  {
    q: 'Come ricevo il materiale?',
    a: 'Immediatamente via email dopo il pagamento.',
  },
  {
    q: 'È aggiornato alle ultime normative?',
    a: 'Sì, include le ultime novità su IVA e Bilancio Civilistico.',
  },
  {
    q: 'Posso stampare i PDF?',
    a: 'Certamente, sono ottimizzati per la stampa in bianco e nero o a colori.',
  },
  {
    q: 'Funziona per tutti e 5 gli anni delle superiori?',
    a: "Sì, copre l'intero percorso ministeriale.",
  },
]
